export default "__VITE_ASSET__4E117a3j__"